interface ITrashPropsType {
  height?: number;
  width?: number;
  color?: string;
}
const TrashIcon: React.FC<ITrashPropsType> = ({ height = 24, width = 24, color = '#337FA3' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 11v6m4-6v6M4 7h16m-1 0-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7h14Zm-4 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3h6Z"
    />
  </svg>
);
export default TrashIcon;
